export default "__VITE_ASSET__B4_C5Axf__"